import Link from 'next/link'
import { Nav } from 'react-bootstrap'
import { Designed } from 'web_core/types'

type Props = {
  link?: string
  articleNavLink?: string
  bookNavLink?: string
  variant?: 'tabs' | 'pills'
  active: 'articles' | 'books'
}

export const ContentNavSelector = ({
  link,
  active,
  articleNavLink,
  bookNavLink,
  variant = 'tabs',
  ...wrapperProps
}: Designed<Props>) => {
  return (
    <Nav variant={variant} {...wrapperProps}>
      <Nav.Item>
        <Link
          href={
            articleNavLink ?? link?.replace('[contents]', 'articles') ?? '/'
          }
          passHref
        >
          <Nav.Link active={active === 'articles'}>記事</Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link
          href={bookNavLink ?? link?.replace('[contents]', 'books') ?? '/'}
          passHref
        >
          <Nav.Link active={active === 'books'}>本</Nav.Link>
        </Link>
      </Nav.Item>
    </Nav>
  )
}
